import {tns} from 'tiny-slider/src/tiny-slider'

class Carousels {
    constructor() {

        this.mobileCarousel = document.querySelectorAll('.mobile-carousel');
        if (this.mobileCarousel.length > 0) {
            this.initHeroFrontBanner();
        }

        this.testimonialCarousels = document.querySelectorAll('.testimonials-carousel');
        if (this.testimonialCarousels.length > 0) {
            this.initTestimonialCarousels();
        }


        this.logosCarousels = document.querySelectorAll('.logos-carousel');
        if (this.logosCarousels.length > 0) {
            this.initLogosCarousel();
        }

        this.galleryCarousels = document.querySelectorAll('.gallery-carousel');
        if (this.galleryCarousels.length > 0) {
            this.initGalleryCarousel();
        }


    }


    initTestimonialCarousels() {
        this.testimonialCarousels.forEach((carouselInstance) => {

            const items = carouselInstance.querySelector('.testimonials-carousel__wrapper');
            const controls = carouselInstance.querySelector('.testimonials-carousel__controls');


            const tnsSlider = tns({
                "container": items,
                "items": 2,
                "slideBy": "page",
                "autoplay": true,
                "autoplayTimeout": 12000,
                "autoplayButton": false,
                "autoplayButtonOutput": false,
                "mouseDrag": true,
                "loop": true,
                "gutter": 12,
                'nav': false,
                "controlsContainer": controls,
                "responsive": {
                    "350": {
                        "items": 1,
                        "edgePadding": 50
                    },
                    "760": {
                        "items": 2,
                        "edgePadding": 0,

                    },
                    "1024": {
                        "gutter": 32,
                    }
                },
            });

        });
    }


    initLogosCarousel() {
        this.logosCarousels.forEach((carouselInstance) => {
            const items = carouselInstance.querySelector('.logos-carousel__wrapper');

            const tnsSlider = tns({
                "container": items,
                "items": 3,
                "slideBy": "page",
                "autoplay": true,
                "autoplayTimeout": 8000,
                "autoplayButton": false,
                "autoplayButtonOutput": false,
                "mouseDrag": true,
                "loop": false,
                'nav': false,
                "controls": false,
                "responsive": {
                    "350": {
                        "items": 3,
                        "edgePadding": 40,
                        "gutter": 32,
                    },
                    "760": {
                        "items": 4,
                        "edgePadding": 0,
                    },
                    "1024": {
                        "items": 4,
                    },
                },
            });
        });
    }

    initHeroFrontBanner() {
        this.mobileCarousel.forEach((carousel) => {
            const carouselItems = carousel.querySelector('.mobile-carousel__wrapper');

            tns({
                "container": carouselItems,
                "autoplay": true,
                "autoplayTimeout": 8000,
                "mouseDrag": true,
                "loop": true,
                "slideBy": 'page',
                'lazyload': false,
                'speed': 1000,
                'controls': false,
                'nav': false,
                'autoplayButtonOutput': false,
                "items": 1,
                "responsive": {
                    "350": {
                        "items": 1,
                        "edgePadding": 50,
                    },
                    "760": {
                        "items": 3,
                        "edgePadding": 30,
                    },
                    "1024": {
                        "disable": true,
                    }
                },
            })
        });
    }

    initGalleryCarousel() {
        this.galleryCarousels.forEach((carouselInstance) => {

            const items = carouselInstance.querySelector('.gallery-carousel__wrapper');
            const controls = carouselInstance.querySelector('.gallery-carousel__controls');


            const tnsSlider = tns({
                "container": items,
                "items": 2,
                "slideBy": "page",
                "autoplay": true,
                "autoplayTimeout": 12000,
                "autoplayButton": false,
                "autoplayButtonOutput": false,
                "mouseDrag": true,
                "loop": true,
                "center": true,
                "gutter": 12,
                'nav': false,
                "controlsContainer": controls,
                "responsive": {
                    "350": {
                        "items": 1,
                        "edgePadding": 50
                    },
                    "760": {
                        "items": 2,

                    },
                    "1024": {
                        "gutter": 32,
                    }
                },
            });

        });
    }
}

export default Carousels;